import { z } from 'zod/v4';

export const fleetJwtSchema = z.object({
  token: z.string().min(1),
  expires: z.string().min(1),
});

export type FleetJwt = z.infer<typeof fleetJwtSchema>;
